import * as React from 'react'
import { connect } from 'react-redux'
import LocationPane from '../../../components/riders/editrider/location/LocationPane'
import * as actions from '../../../state/actions/riders'
import * as riderLocationActions from '../../../state/actions/rider-locations'
import { getRiderLocationsList } from '../../../state/reducers/rider-location'
import { getRiderById } from '../../../state/reducers/riders'
import { IRiderLocationObject, IRiderObject, IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const { riderId } = ownProps

  return {
    riderId,
    rider: getRiderById(state.riders, riderId),
    riderLocations: getRiderLocationsList(state.riderLocations),
    zoom: state.mapView.zoom,
    bounds: state.mapView.bounds
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderLocationList: (riderId: string): any => {
      return dispatch(actions.getRiderLocationList(riderId))
    },
    saveLocations: (rider: IRiderObject, locations: IRiderLocationObject[]) => {
      return dispatch(actions.updateRiderLocations(rider, locations))
    },
    createLocation: (riderId: string, location: IRiderLocationObject): Promise<IRiderLocationObject> => {
      return dispatch(riderLocationActions.createLocation(riderId, location))
    },
    deleteLocation: (riderId: string, id: string) => {
      return dispatch(riderLocationActions.removeLocation(riderId, id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationPane)



// WEBPACK FOOTER //
// ./src/containers/riders/editrider/LocationPane.ts